import SurveyTakerPage from './SurveyTakerPage';

export default SurveyTakerPage;
